import { SET_DATE, CLEAR_DATE } from '../actionTypes';
import {formatDate} from "../../../helpers";

const initialState = {
    calendarRange: {
        defaultDate: new Date(),
        endOfCalendarView: formatDate("end"),
        startOfCalendarView: formatDate("start"),
    }
};

const sharedReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_DATE:
            return {
                ...state,
                calendarRange: {
                    ...state.calendarRange,
                    ...action.payload
                },
            };
        case CLEAR_DATE:
            return {
                ...state,
                calendarRange: initialState.calendarRange
            };
        default:
            return state;
    }
};

export default sharedReducer;



// WEBPACK FOOTER //
// ./src/shared/redux/reducers/sharedReducer.js